import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  output,
} from '@angular/core';

import { AlertsComponent, AlertsService } from '@web/shared/ui';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HttpErrorService } from '@web/common';
import { HttpErrorResponse } from '@angular/common/http';
import { AdminDictionaryCountryDetailsFormComponent } from '../../components/admin-dictionary-country-details-form/admin-dictionary-country-details-form.component';
import { AdminDictionaryCountryDetailsForm } from '../../models/admin-dictionary-country-details-form';
import { AdminDictionaryCountryDataSourceService } from '../../services/admin-dictionary-country-data-source.service';

@Component({
  selector: 'app-admin-dictionary-country-create',
  imports: [AlertsComponent, AdminDictionaryCountryDetailsFormComponent],
  templateUrl: './admin-dictionary-country-create.component.html',
  styleUrl: './admin-dictionary-country-create.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class AdminDictionaryCountryCreateComponent {
  /* prettier-ignore */
  private readonly adminDictionaryDataSource = inject(AdminDictionaryCountryDataSourceService);
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);

  public readonly submitSuccessEvent = output();

  private readonly destroyRef = inject(DestroyRef);

  public handleSubmitClickEvent(data: AdminDictionaryCountryDetailsForm): void {
    this.adminDictionaryDataSource
      .createByFormData(data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => this.submitSuccessEvent.emit(),
        error: (response) => this.showFailureAlertByResponse(response),
      });
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    const messages = this.httpError.extract(response).messages();

    this.alerts.showMultiple((builder) =>
      messages.map((message) => builder.buildFailure(message)),
    );
  }
}
